module.exports = __webpack_public_path__ + "178676ea90516cf95ef87dbc42f84274.svg";